import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { _retrieveStaffDetails } from "../../../store/actions/staff";
import { dateFormat } from "../../../utils/helper";
import PageTableHeader from "../../components/pageTableHeader/pageTableHeader";
import ContentCard from "../common/profile/contentCard";
import { _fetchUserData } from "../../../store/actions/user";
import useUserRole from "../../../hooks/useUserRole";
import { _userRole } from "../../../utils/common";
import DefaultButton from "../../components/buttons/defaultButton";
import CustomTab, { TabContainer } from "../../components/tabs/customTabs";
import { getUserDetailProfile } from "../../../services/workspace/user.service";
import useCommonFetch from "../../../hooks/useCommonFetch";
import OverviewProfile from "./overview";

function ProfileView() {
  const { pathname } = useLocation();
  const { id } = useParams();
  const role = useUserRole();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const user = userInfo?.user || { name: "User" };
  const [data, setData] = useState();
  const [personalInfo, setPersonalInfo] = useState([]);
  const [parentInfo, setParentInfo] = useState([]);
  const [academicCard, setAcademicCard] = useState([]);
  const [workCard, setWorkCard] = useState([]);
  const [addressCard, setAddressCard] = useState([]);
  const [contactCard, setContactCard] = useState([]);
  const [licenseCard, setLicenseCard] = useState([]);
  const [reporting, setReporting] = useState([]);
  

  const items = [
    { label: "Profile", path: "" },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);

 

  const {
      loading,
      data: staffData,
      fetchData,
    } = useCommonFetch(getUserDetailProfile, {
      id: user.uuid,
      dataPath: "user",
      errorMessage: "Failed to fetch user detail!",
      customParams: {
        additional_info: true,
        // with: "workspace,createdBy,designation,department,educations,experiences,attendances,documents,leaves",
      },
    });
  
    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const tabFromUrl = Number(params.get("tab"));
      if (!isNaN(tabFromUrl)) {
        setActiveTab(tabFromUrl);
      }
    }, [location.search]);
  
    // ✅ when user clicks tab
    const handleTabChange = (tabId) => {
      setActiveTab(tabId);
      navigate(`?tab=${tabId}`);
    };
  
    const heandleFetchData = () => {
      fetchData(
        {
          additional_info: true,
          with: "workspace,createdBy,designation,department,educations,experiences,attendances,documents,leaves",
        },
        true,
        id
      );
    };


  const tabs = [
    {
      id: "tab1",
      label: "Overview",
      content: <OverviewProfile fetchData={fetchData} staff={staffData} user={user} loading={loading} heandleFetchData={heandleFetchData} />,
    },
    // {
    //   id: "tab2",
    //   label: "Education",
    //   content: <EducationCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData ={heandleFetchData}/>,
    // },
    // {
    //   id: "tab3",
    //   label: "Experience",
    //   content: <ExperienceCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData ={heandleFetchData} />,
    // },
    // {
    //   id: "tab4",
    //   label: "Attendance",
    //   content: <AttendanceCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData={heandleFetchData}/>,
    // },
    // {
    //   id: "tab5",
    //   label: "Leaves",
    //   content: <LeaveCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData={heandleFetchData} />,
    // },
    // {
    //   id: "tab6",
    //   label: "Documents",
    //   content: <DocumentCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData={heandleFetchData} />,
    // }, 
  ];


  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-2 min-w-[400px] overflow-auto">
        <PageTableHeader
          breadcrumbs={items}
          isSearch={false}
          isFilter={false}
          buttons={
            <DefaultButton
              name={"Edit Profile"}
              onClick={() => navigate(`/profile/edit`)}
            />
          }
        />
        {/* <div>
          <div className="grid md:grid-cols-2 gap-2 p-4 bg-white">
            <div className="flex flex-col gap-2">
              <ContentCard title="Personal Information" data={personalInfo} />
              <ContentCard title="Parent Information" data={parentInfo} />
              {user?.user_info?.license_number ? (
                <ContentCard title="Documents Information" data={licenseCard} />
              ) : (
                ""
              )}
            </div>

            <div className="flex flex-col gap-2">
              {role === _userRole.STUDENT ? (
                <ContentCard title="Academic Information" data={academicCard} />
              ) : (
                <ContentCard title="Work Information" data={workCard} />
              )}
              <ContentCard title="Contact Information" data={contactCard} />
              <ContentCard title="Address" data={addressCard} />

            </div>
          </div>
        </div> */}

        <div className="flex flex-col gap-2">
          <div className="overflow-y-auto scrollbar-hidden">
            <TabContainer tabs={tabs} activeTab={activeTab} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileView;
